import { IChildProp } from "@intelligence/components/Form/type";
import { convertDataSourceAndSource } from "@intelligence/_config/enumeration/dataSource";

const COMPANIES_DATA_SOURCE = {
  mobileMetrics: ['mobileRevenue_mobileMetrics', 'mobileDownload_mobileMetrics'],
  pcMetrics: ['pcDigitalRevenue_pcMetrics', 'pcPhysicalRevenue_pcMetrics', 'pcSteamPCU_pcMetrics', 'pcMAU_pcMetrics'],
  consoleMetrics: ['consoleDigitalRevenue_consoleMetrics', 'consolePhysicalRevenue_consoleMetrics', 'consoleMAU_consoleMetrics'],
  gamesOwned: [],
};

const getMetricsChildren = () => convertDataSourceAndSource(COMPANIES_DATA_SOURCE, {
  isDefault: {
    mobileMetrics: 'all',
    pcMetrics: 'all',
    consoleMetrics: 'all',
    gamesOwned: 'all',
  }
});

const COMPANIES_DETAIL_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'companiesMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        isDefault: true,
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
        msgKey: 'dbi_info_mobile_time_settings_info',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

export default {
  companiesDetail: COMPANIES_DETAIL_DOWNLOAD_SET
};

